// extracted by mini-css-extract-plugin
export default {"root":"styles_root__18z9M","zoomOut":"styles_zoomOut__4eZeZ"};